import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSelectionListChange } from '@angular/material/list';
import { BaseModalComponent } from 'src/app/core/base-modal.componant';
import { BookingList } from '../../../models/booking-list';
import { DigitalWaiverService } from '../../../services/digital-waiver.service';
import { BookingService } from '../../../services/booking.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { DigitalWaiver } from '../../../models/digital-waiver';

@Component({
    selector: 'waiver-entry-manual-create-modal',
    templateUrl: './waiver-entry-manual-create-modal.component.html',
    styleUrl: './waiver-entry-manual-create-modal.component.scss',
    standalone: false
})
export class WaiverEntryManualCreateModalComponent extends BaseModalComponent implements OnInit {
    public form = new FormGroup({
        bookingId: new FormControl('', [Validators.required]),
        firstName: new FormControl('', [Validators.required]),
        lastName: new FormControl('', [Validators.required]),
        emailAddress: new FormControl('', [Validators.required, Validators.email]),
        digitalWaiverEntryId: new FormControl('')
    });

    public upcomingBookings: BookingList[] = [];
    public filteredBookings: BookingList[] = [];
    private selectedBooking: BookingList;
    public searchText: string = '';
    private activeDigitalWaiver: DigitalWaiver;

    constructor(
        private digitalWaiverService: DigitalWaiverService,
        private bookingService: BookingService,
        private sessionService: SessionService,
        public dialogRef: MatDialogRef<WaiverEntryManualCreateModalComponent>
    ) {
        super();
    }

    ngOnInit(): void {
        this.loadUpcomingBookings();
    }

    loadUpcomingBookings() {
        this.isLoading = true;
        let now = new Date();
        const nowUtc = new Date(Date.UTC(
            now.getFullYear(),
            now.getMonth(),
            now.getDate(),
            now.getHours(),
            now.getMinutes()
          ));

        const filter = {
            organizationId: this.sessionService.getUser().organizationId,
            fromDate: nowUtc,
            pageSize: 100
        };

        this.bookingService.getAllByOrganization(filter).subscribe({
            next: (result: any) => {
                this.upcomingBookings = result.results;
                this.filteredBookings = [...this.upcomingBookings];
                this.getActiveDigitalWaiver();
            },
            error: (error) => {
                console.error(error);
                this.isLoading = false;
            }
        });
    }

    getActiveDigitalWaiver() {
        this.digitalWaiverService.getActiveDigitalWaiver(this.sessionService.getUser().organizationId).subscribe({
            next: (result: any) => {
                this.activeDigitalWaiver = result;
                this.isLoading = false;
            },
            error: (error) => {
                console.error(error);
                this.isLoading = false;
            }
        });
    }

    filterBookings() {
        if (!this.searchText) {
            this.filteredBookings = [...this.upcomingBookings];
            return;
        }

        const searchLower = this.searchText.toLowerCase();
        this.filteredBookings = this.upcomingBookings.filter(booking => 
            booking.customerName.toLowerCase().includes(searchLower) ||
            booking.email.toLowerCase().includes(searchLower) ||
            booking.confirmationNumber.toLowerCase().includes(searchLower)
        );
    }

    onBookingSelection(event: MatSelectionListChange) {
        this.selectedBooking = event.options[0].value as BookingList;
        this.form.patchValue({
            bookingId: this.selectedBooking.id,
            firstName: this.selectedBooking.customerName.split(' ')[0],
            lastName: this.selectedBooking.customerName.split(' ').slice(1).join(' '),
            emailAddress: this.selectedBooking.email,
            digitalWaiverEntryId: this.selectedBooking.digitalWaiverEntryId
        });
    }

    submit() {
        if (this.form.valid) {
            this.isLoading = true;

            let now = new Date();
            const nowUtc = new Date(Date.UTC(
                now.getFullYear(),
                now.getMonth(),
                now.getDate(),
                now.getHours(),
                now.getMinutes()
              ));

            const data = {
                ...this.form.value,
                organizationId: this.sessionService.getUser().organizationId,
                lastEditedBy: this.sessionService.getUserId(),
                digitalWaiverEntryId: this.form.value.digitalWaiverEntryId,
                digitalWaiverId: this.activeDigitalWaiver.id,
                sentDate: nowUtc,
                userId: this.sessionService.getUserId(),
            };

            if(this.selectedBooking.email != this.form.value.emailAddress) {
                data.digitalWaiverEntryId = null;
            }

            this.digitalWaiverService.manuallySendWaiver(data).subscribe({
                next: () => {
                    this.dialogRef.close('save');
                },
                error: (error) => {
                    this.setError(error, this.form);
                    this.isLoading = false;
                }
            });
        }
    }
} 